export default __webpack_public_path__ + "static/media/IMG_5962.b31a185f.jpg";